export default __webpack_public_path__ + "static/media/SELLOS_DISCOS_01.35811f06.png";